import { Modal } from "@/components/modal/Modal";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useState } from "react";
import IconButton from "@/components/buttons/IconButton";
import type { IQuestion } from "@/types/types";
import { useLanguage } from "@/context/language-context/LanguageContext";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import { useQuestionsForm } from "@/store/useQuestionsForm";
import Title from "@/components/modal/Title";

const ModalRemoveQuestion = ({
  question,
  index,
}: {
  question: IQuestion;
  index: number;
}) => {
  const { language } = useLanguage();
  const translate = useTranslate();
  const { removeQuestion } = useQuestionsForm();
  const [isRemoving, setIsRemoving] = useState(false);

  const handleOnRemove = () => {
    setIsRemoving(true);
  };

  const handleOnClose = () => {
    setIsRemoving(false);
  };

  const hanldeOnConfirmRemove = () => {
    removeQuestion(question.questionId);
    handleOnClose();
  };

  return (
    <>
      <IconButton icon="trash" onClick={handleOnRemove} />
      {isRemoving && (
        <Modal>
          <Modal.Header>
            <Title title={translate("removeQuestion")} />
          </Modal.Header>
          <Modal.Content>
            <div className="flex flex-col space-y-6">
              <p>
                {translate("removeQuestionDescription", [index.toString()])}
              </p>
              <p className="font-ib-bold">{question[language]}</p>
            </div>
          </Modal.Content>
          <Modal.Footer>
            <div className="w-full flex justify-between">
              <div>
                <SecondaryButton
                  onClick={handleOnClose}
                  label={translate("cancel")}
                  colour={"red"}
                />
              </div>
              <div>
                <PrimaryButton
                  onClick={hanldeOnConfirmRemove}
                  label={translate("remove")}
                  colour={"red"}
                />
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ModalRemoveQuestion;
